import { API, graphqlOperation } from 'aws-amplify'

const operation = `
    mutation CreateTrainingResult(
        $input: createTrainingResultInput
    ) {
        createTrainingResult(
            input: $input
        ) {
            certificateType
            createdAt
            d1
            d2
            firstName
            lastName
            pk
            quizzesCompleted
            sk
            title {
                language
                text
            }
            userType
            version
            videosCompleted
        }
    }
`

const CreateTrainingResult = (data, onRead) =>
    API.graphql(graphqlOperation(operation, data)).then(onRead)

export default CreateTrainingResult
